import { jsx as _jsx } from "react/jsx-runtime";
import './QPageMessage.scss';
export const QPageMessage = (props) => {
    return _jsx("div", { className: 'page-message', children: props.message });
};
//# sourceMappingURL=QPageMessage.js.map